import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { t } from 'ember-intl';
import { and, eq, gt, not } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Button from 'umg-ember-backend/components/ui/button';
import Modal from 'umg-ember-backend/components/ui/modal';
import Window from 'umg-ember-backend/components/ui/window';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

export class SearchAdUser extends Component {
  // Services
  @service fetch;
  @service intl;

  // Defaults
  @tracked searchValue = '';
  @tracked searchResults = [];
  @tracked errorMessage;

  searchAdUser = async () => {
    try {
      const result = await this.fetch.request('/ad-search', {
        data: {
          email: this.searchValue,
        },
      });

      if (!Array.isArray(result) || result.length === 0) {
        this.errorMessage = this.intl.t(
          'record_detail.forms.user.search_ad_user.no_results',
          {
            email: this.searchValue,
          },
        );
      } else {
        this.errorMessage = undefined;
      }

      this.searchResults = result || [];
    } catch (error) {
      this.errorMessage = error;
    }
  };

  updateSearchValue = (event) => {
    this.searchValue = event.target.value;
  };

  closeSearch = () => {
    this.args.user.oid = null;
    this.args.user.userType = null;
  };

  createUser = (user) => {
    const { id, surname, givenName, mail } = user;

    const person = this.store.createRecord('person', {
      firstname: givenName,
      lastname: surname,
      email: mail,
    });

    person.save();

    this.args.user.person = person;
    this.args.user.oid = id;
    if (!this.args.user.name) {
      const truncatedSurname = surname.substring(0, 6);
      const truncatedGivenName = givenName.substring(0, 1);
      this.args.user.name = `${truncatedSurname}${truncatedGivenName}`;
    }
  };

  // Template
  <template>
    <Modal
      @onClose={{this.closeSearch}}
      @dataDependencies={{and (eq @user.userType 'INTERNAL') (not @user.oid)}}
    >
      <Window>
        <:title>
          {{t 'record_detail.forms.user.search_ad_user.title'}}
        </:title>
        <:body>
          <div class={{(bem)}}>
            <div class={{bem 'field'}}>
              <label for='search-ad-user'>
                {{t 'record_detail.forms.user.search_ad_user.label'}}
              </label>
              <input
                type='text'
                value={{this.searchValue}}
                id='search-ad-user'
                placeholder={{t
                  'record_detail.forms.user.search_ad_user.placeholder'
                }}
                {{on 'input' this.updateSearchValue}}
              />
            </div>
            <Button
              {{on 'click' this.searchAdUser}}
              @label={{t 'record_detail.forms.user.search_ad_user.search_user'}}
            />
          </div>
          {{#if this.errorMessage}}
            <div class={{bem 'error-message'}}>{{this.errorMessage}}</div>
          {{/if}}

          {{#if (gt this.searchResults.length 0)}}
            <div class={{bem 'results'}}>
              {{#each this.searchResults as |result|}}
                {{result.displayName}}
                <Button
                  {{on 'click' (fn this.createUser result)}}
                  @label={{t
                    'record_detail.forms.user.search_ad_user.create_user'
                  }}
                  @size='small'
                />
              {{/each}}
            </div>
          {{/if}}
        </:body>
      </Window>
    </Modal>
  </template>
}
